import Frtabs from 'fr-tabs/dist/frtabs.min';
import throttle from 'raf-throttle';

const tabs = Frtabs();
const breakpoint = '(min-width: 560px)';

function testBreakpoint() {
  if (window.matchMedia(breakpoint).matches) {
    tabs.init();
  } else {
    tabs.destroy();
  }
}

window.addEventListener(`resize`, throttle(testBreakpoint), { passive: true });
testBreakpoint();
